import qs from 'qs';

import { SortEnum } from 'src/queries/__global_generated__/globalTypes';

export type UrlParams = {
    currentPage?: number;
    pageSize?: number | null;
    sortBestsellers?: SortEnum;
    sortName?: SortEnum;
    sortPrice?: SortEnum;
};

export function deserializeUrl(search: string): UrlParams {
    const params = search.substr(1);
    const obj = qs.parse(params);
    const output: UrlParams = {};

    if (obj.order === 'name' && (obj.dir === SortEnum.ASC || obj.dir === SortEnum.DESC)) {
        output.sortName = obj.dir;
    }

    if (obj.order === 'price' && (obj.dir === SortEnum.ASC || obj.dir === SortEnum.DESC)) {
        output.sortPrice = obj.dir;
    }

    if (obj.order === 'bestsellers' && obj.dir === SortEnum.ASC) {
        output.sortBestsellers = obj.dir;
    }

    if (obj.page && obj.page !== '') {
        output.currentPage = obj.page as any;
    }

    if (obj.show) {
        output.pageSize = Number(obj.show);
    }

    return output;
}
